// ORIAS Essentials — Custom Homepage Enhancements

document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('template-index')) return;
  // Brand statement is now overlaid on the hero via section-video; no JS injection needed.
});
